const GENERATE_SOURCEMAP = false;
const {
  VITE_TRYTON_API_HOST: apiHost,
  VITE_TRYTON_API_PORT: apiPort,
  VITE_TRYTON_API_KEY: api_key,
  VITE_OPENPAY_API_KEY: api_openpay,
  VITE_CLOUDINARY_UPLOAD_PRESET: CLOUDINARY_UPLOAD_PRESET,
  VITE_CLOUDINARY_UPLOAD_URL: CLOUDINARY_UPLOAD_URL,
  VITE_CLOUDINARY_UPLOAD_URL2: CLOUDINARY_UPLOAD_URL2,
  VITE_CLOUDINARY_API_KEY: CLOUDINARY_API_KEY,
  CLOUDINARY_API_SECRET: CLOUDINARY_API_SECRET,
  VITE_GOOGLE_MAP_API_KEY: GOOGLE_MAP_API_KEY,
  MODE: mode,
} = import.meta.env;

console.log("running on :", mode);
let http = "http";

if (mode === "production") {
  http = "https";
}

// console.log("ENV VARS ....", import.meta.env);
console.log("Api connection :", apiHost, apiPort);
let api = `${http}://${apiHost}:${apiPort}/`;

export default {
  api,
  api_key,
  api_openpay,
  CLOUDINARY_UPLOAD_PRESET,
  CLOUDINARY_UPLOAD_URL,
  CLOUDINARY_UPLOAD_URL2,
  CLOUDINARY_API_SECRET,
  CLOUDINARY_API_KEY,
  GOOGLE_MAP_API_KEY,
  GENERATE_SOURCEMAP,
};
